module.exports = __webpack_public_path__ + "img/en-diag-placeholder.4f72cd75.png";